import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SelectionScreen from './components/SelectionScreen';
import RijaShop from './components/RijaShop';
import SreeShop from './components/SreeShop';
import RedeemedRewards from './components/RedeemedRewards';
import CompletedChores from './components/CompletedChores';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SelectionScreen />} />
        <Route path="/rija" element={<RijaShop />} />
        <Route path="/sree" element={<SreeShop />} />
        <Route path="/redeemed-rewards/:user" element={<RedeemedRewards />} />
        <Route path="/completed-chores/:user" element={<CompletedChores />} />
      </Routes>
    </Router>
  );
}

export default App;
